import { Navigate }                        from 'react-router-dom';
import { useNavigate }                     from 'react-router-dom';
import { Box }                             from "@chakra-ui/react";
import { Text }                            from "@chakra-ui/react";
import { Button }                          from '@/components/ui/button';
import Drawer                              from "@/components/drawer/Drawer";
import { Grid }                            from "@chakra-ui/react";
import { GridItem }                        from "@chakra-ui/react";
import LogoutIcon                          from '@/assets/icons/LogoutIcon';
import NavBar                              from "@/components/navbar/NavBar";
import NavigationFooter                    from "@/components/navigation/NavigationFooter";
import NavigationMenu                      from "@/components/navigation/NavigationMenu";
import { Outlet }                          from 'react-router-dom';
import React                               from 'react';
import Spinner                             from "@/components/spinner/Spinner";
import { SystemStyleObject }               from "@chakra-ui/react";
import UserMeModel                         from '@/models/services/fondations/UserMeModel';
import authStore                           from '@/stores/authStore';
import useFetch                            from "@widesk-core/hooks/useFetch";
import { useLocation }                     from 'react-router-dom';
import useMenu                             from "@/hooks/useMenu";
import useScreenSize                       from "@/hooks/useScreenSize";
import { useState }                        from 'react';
import { useTranslation }                  from "react-i18next";
import useTranslations                     from "@/hooks/useTranslations";
import { Alert }                           from '@/components/ui/alert';
import './protectedRoute.scss';

const ProtectedRoute: React.FC = () => {
    const location = useLocation();
    const isAuthenticated = authStore.isAuthenticated;
    const isImpersonate = authStore.isImpersonate;
    const { getCurrentPageKey } = useMenu();
    const [isOpen, setIsOpen] = useState(false);
    const { isLG, screenSize } = useScreenSize();
    const { t } = useTranslation();
    const { getNavigationTranslation } = useTranslations();
    const currentPageKey = getCurrentPageKey();
    const navigate = useNavigate();

    useFetch(async () => {
        if (isAuthenticated && !authStore.currentUser) {
            const user = await new UserMeModel().fetch();
            authStore.setCurrentUser(user);
        }
	}, true);

    React.useEffect(() => {
        if (isLG) {
            if (isOpen === true) {
                setIsOpen(false);
            }
        }
    }, [screenSize]);

    const styles: {
        [key: string]: {
            [key: string]: SystemStyleObject
        }
    } = {
        container: {
            base: {
                height: `calc(100vh - 72px ${isImpersonate ? '- 72px' : ''})`,
                gridTemplateColumns: "1fr"
            },
            lg: {
                gridTemplateColumns: "400px 1fr",
                width: "100%"
            }
        }
    };

    // Si l'utilisateur n'est pas authentifié et qu'il essaye d'accéder à une page protégée, alors on le redirige vers la page de login.
    if (!isAuthenticated && currentPageKey?.type === 'private') {
        const fromPath = location.pathname;
        sessionStorage.setItem('loginRedirectPath', fromPath);
        return <Navigate to={getNavigationTranslation('login', 'path')} replace />;
    }

    // Si l'utilisateur n'est pas authentifié et qu'il essaye d'accéder à une page qui n'existe pas, alors on le redirige vers la page de login.
    if (!isAuthenticated && currentPageKey === undefined) {
        return <Navigate to={getNavigationTranslation(`login`, 'path')} />;
    } 

    /* 
        Si l'utilisateur n'est pas authentifié et qu'il essaye d'accéder à une page qui existe,
        mais qu'il utilise un pathname d'une langue différente que celle de utilisée par l'application
        alors on le redirige vers le bon path en fonction de la langue utilisée par l'application.
    */
    if (!isAuthenticated && !!currentPageKey && location.pathname !== getNavigationTranslation(currentPageKey.label, 'path')) {
        return <Navigate to={getNavigationTranslation(currentPageKey.label, 'path')} />;
    } 

    if (authStore.currentUser) {
        return (
            <>
                {
                    isImpersonate &&
                    <div id='protected-route-impersonate-alert'>
                        <Alert 
                            status="warning" 
                            title={
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                >
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        flexWrap="wrap"
                                    >
                                        <Text>{t('app.impersonate.alert.title', { fullname: authStore.currentUser.fullName })}&nbsp;</Text>
                                        <Text fontStyle="italic">{t('app.impersonate.alert.email', { email: authStore.currentUser.email })}</Text>
                                    </Box>
                                    <Button
                                        onClick={() => {
                                            authStore.logout();
                                            navigate(getNavigationTranslation('login', 'path'), { state: null });
                                        }}
                                    >
                                        <LogoutIcon fontSize="20px" />
                                        {t('components.drawer.actions.logout')}
                                    </Button>
                                </Box>
                            } 
                        />
                    </div>
                }
                <Drawer isOpen={isOpen} setIsOpen={setIsOpen}>
                    <NavBar setIsOpen={setIsOpen} />
                    <Grid
                        {...styles.container.base}
                        lg={styles.container.lg}
                    >
                        <GridItem
                            hideBelow="lg"
                        >
                            <Grid bg="white" gridTemplateRows="0.9fr 0.1fr" height="100%">

                                <GridItem>
                                    <NavigationMenu />
                                </GridItem>

                                <GridItem alignSelf="center">
                                    <NavigationFooter />
                                </GridItem>

                            </Grid>
                        </GridItem>

                        <GridItem overflow="auto">
                            <Outlet />
                        </GridItem>
                    </Grid>
                </Drawer>
            </>
        );
    }   

    return (
        <Box
            width="100vw"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
        >
            <Box margin="10%"><Spinner /></Box>
            <Box margin="10%">
                <Button
                    variant="ghost"
                    onClick={() => {
                        authStore.logout();
                        navigate(getNavigationTranslation('login', 'path'), { state: null });
                    }}
                    justifyContent="flex-start"
                    paddingLeft={0}
                    marginLeft={{ base: 0, lg: "30px" }}
                    marginRight={{ base: 0, lg: "30px" }}
                    _hover={{ bg: "beigeLight" }}
                >
                    <LogoutIcon fontSize="20px" />
                    {t('components.drawer.actions.logout')}
                </Button>
            </Box>
        </Box>
    )
};

export default ProtectedRoute;